import React from 'react';
import { observer, inject } from 'mobx-react';
import moment from 'moment';
import {
  Grid,
  TextField,
  Paper,
  withStyles,
  Button,
  Checkbox,
  FormHelperText,
  Select,
  MenuItem,
} from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';
import { tenantInfo } from '../../utils/tenantInformation';
import '../devices/styles/devicepage.css';

const errRequired = 'required_field';
const errInvalidField = 'this_field_is_invalid';

class RoutersPage extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    this.handleChangeOutOfAreaCheckbok = this.handleChangeOutOfAreaCheckbok.bind(this);
    this.handleChangeLocalizationCheckbok = this.handleChangeLocalizationCheckbok.bind(this);
    // this.initData = this.initData;
    this.state = {
      tenants: [],
      data: {
        id: '',
        name: '',
        placeName: '',
        tenantId: 0,
        routerId: '',
        mapId: null,
        referenceNumber: '',
        routerType: '',
        manufacturer: '',
        purchasedDate: '',
        description: '',
        map: '',
        useForLocalization: false,
        outOfAreaDefault: false,
        serial: '',
        version: '',
      },
      checked: false,
      errorField: {
        name: {
          flag: false,
          msg: '',
        },
        placeName: {
          flag: false,
          msg: '',
        },
        tenantId: {
          flag: false,
          msg: '',
        },
        routerId: {
          flag: false,
          msg: '',
        },
        routerType: {
          flag: false,
          msg: '',
        },
        manufacturer: {
          flag: false,
          msg: '',
        },
        purchasedDate: {
          flag: false,
          msg: '',
        },
      },
    };
  }

  async componentDidMount() {
    const tenants = tenantInfo();
    this.setState({ tenants });

    const { offset, limit, search, sort, order, tenantIds } = this.props.router.toJS();
    await this.props.router.getRouterList(offset, limit, search, sort, order, tenantIds);
    await this.props.routerType.getRouterTypeList(0, 0);
    this.initData();
  }

  goBack() {
    this.props.router.setAction('action', true);
    this.props.history.goBack();
  }

  initData() {
    const { routerList, tenantIds } = this.props.router.toJS();
    const { id } = this.props.match.params;
    const routerId = Number(id);
    const showData = routerList.data.find((item) => item.id === routerId);
    if (showData) {
      this.setState({
        data: {
          id: showData.id || '-',
          name: showData.name || '-',
          placeName: showData.place || '-',
          routerId: showData.serial || '-',
          tenantId: showData.tenantId,
          mapId: showData.mapId,
          referenceNumber: showData.referenceNumber || '-',
          // manufacturer: showData.manufacturer || '-',
          purchasedDate: showData.purchasedDate ? moment(new Date(showData.purchasedDate)).format('YYYY-MM-DD') : '-',
          description: showData.description || '-',
          // map: showData.map || 'Not Assigned',
          useForLocalization: showData.useForLocalization !== null ? showData.useForLocalization : true,
          outOfAreaDefault: showData.outOfAreaDefault || false,
          version: showData.version || '-',
          routerType: showData.routerType || '',
        },
      });
    } else {
      const tenants = tenantInfo();
      if (tenants.length === 1) {
        tenants.forEach((g) => {
          this.setState({ data: { tenantId: g.id } });
        });
      } else if (tenantIds && tenantIds.length === 1) {
        tenantIds.forEach((id) => {
          this.setState({ data: { tenantId: id } });
        });
      }
    }
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
  };

  handleChangeOutOfAreaCheckbok(evt) {
    //if (this.state.checked !== evt.target.checked) {
    this.setState({
      ...this.state,
      data: { ...this.state.data, outOfAreaDefault: evt.target.checked },
      checked: evt.target.checked,
    });
    //}
  }

  handleChangeLocalizationCheckbok(evt) {
    //if (this.state.checked !== evt.target.checked) {
    this.setState({
      ...this.state,
      data: { ...this.state.data, useForLocalization: evt.target.checked },
      checked: evt.target.checked,
    });
    //}
  }

  validate() {
    const { data } = this.state;
    // if (!data.name || !data.routerId || !data.manufacturer) {
    let checkName = !data.name ? true : false;
    let checkPlaceName = !data.placeName ? true : false;
    let checkRouterId = !data.routerId ? true : false;
    let checkTenantId = !data.tenantId ? true : false;
    let checkRouterType = !data.routerType ? true : false;
    // let checkManufacturer = !data.manufacturer ? true : false;
    let checkPurchasedDate = false;
    let msg = '';
    if (data.purchasedDate) {
      const date = moment(data.purchasedDate, 'YYYY-MM-DD', true);
      const futureDate = moment();
      checkPurchasedDate = !(date.isValid() && date.isSameOrBefore(futureDate));
      msg = checkPurchasedDate ? errInvalidField : '';
    } else {
      checkPurchasedDate = true;
      msg = errRequired;
    }
    this.setState({
      errorField: {
        name: {
          flag: checkName,
          msg: errRequired,
        },
        placeName: {
          flag: checkPlaceName,
          msg: errRequired,
        },
        tenantId: {
          flag: checkTenantId,
          msg: errRequired,
        },
        routerId: {
          flag: checkRouterId,
          msg: errRequired,
        },
        routerType: {
          flag: checkRouterType,
          msg: errRequired,
        },
        // manufacturer: {
        //   flag: checkManufacturer,
        //   msg: errRequired,
        // },
        purchasedDate: {
          flag: checkPurchasedDate,
          msg,
        },
      },
    });
    // return false;
    // } else {
    //   this.setState({
    //     errorField: {
    //       name: false,
    //       routerId: false,
    //       manufacturer: false,
    //       purchasedDate: false,
    //     }
    //   });
    // }
    return !(checkName || checkPlaceName || checkTenantId || checkRouterId || checkPurchasedDate || checkRouterType);
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'placeName') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          placeName: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'tenantId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          tenantId: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'routerId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          routerId: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    if (key === 'routerType') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          routerType: {
            flag: false,
            msg: '',
          },
        },
      });
    }
    // if (key === 'manufacturer') {
    //   this.setState({
    //     ...this.state,
    //     errorField: {
    //       ...this.state.errorField,
    //       manufacturer: {
    //         flag: false,
    //         msg: '',
    //       }
    //     }
    //   });
    // }
    if (key === 'purchasedDate') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          purchasedDate: {
            flag: false,
            msg: '',
          },
        },
      });
    }
  }

  handleCreateRouter = async (data) => {
    const { t } = this.props;
    if (this.validate()) {
      try {
        const result = await this.props.router.createRouter(data);
        if (result.statusCode === 200) {
          Swal.fire({ html: `<h4>${t('create_success')}`, type: 'success' }).then(async (resultSuccess) => {
            if (resultSuccess.value) {
              this.props.history.push('../routers');
            }
          });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = e.error.error || `${t('failed_to_create')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
      }
    }
  };

  handleEditRouter(data) {
    const { t } = this.props;
    if (this.validate()) {
      Swal.fire({
        html: `<h4>${t('edit_router')}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${t('edit')}`,
        cancelButtonText: `${t('cancel')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          try {
            const result = await this.props.router.updateRouter(data);
            if (result.statusCode === 200) {
              Swal.fire({ html: `<h4>${t('update_success')}`, type: 'success' }).then(async (resultSuccess) => {
                if (resultSuccess.value) {
                  this.props.router.setAction('action', true);
                  this.props.history.push('../../routers');
                }
              });
            }
          } catch (e) {
            if (e.statusCode === 401) {
              clearLocalStorage();
              window.location.href = '/login';
            } else if (e.statusCode === 400) {
              const msg = e.error.error || `${t('failed_to_update')}`;
              Swal.fire({ html: `<h4>${msg}`, type: 'error' });
            } else {
              Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
            }
          }
        }
      });
    }
  }

  renderFormCreate() {
    const { classes, t } = this.props;
    const { routerTypes } = this.props.routerType.toJS();
    const { data, tenants } = this.state;
    return (
      <React.Fragment>
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_router')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || 0}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                >
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || 'tenants'}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId.flag : true}
                id='component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.name.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('place_name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='placeName'
                name='placeName'
                fullWidth
                value={data.placeName || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.placeName.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.placeName.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.placeName.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('router_id')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='routerId'
                name='routerId'
                fullWidth
                value={data.routerId || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.routerId.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.routerId.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('router_reference_number')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='referenceNumber'
                name='referenceNumber'
                fullWidth
                value={data.referenceNumber || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('router_type')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.routerType || ''}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'routerType',
                    id: 'routerType',
                  }}
                >
                  {(routerTypes.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || 'routerType'}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.routerType.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.routerType.msg}`)}
              </FormHelperText>
            </Grid>

            {/* <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('manufacturer_id')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id="manufacturer"
                name="manufacturer"
                fullWidth
                value={data.manufacturer}
                onChange={this.handleChange}
                variant="outlined"
                margin="dense"
              />
              <FormHelperText
                error
                hidden={
                  !data.reset ? !this.state.errorField.manufacturer.flag : true
                }
                id="component-error-text"
              >
                {t(`${this.state.errorField.manufacturer.msg}`)}
              </FormHelperText>
            </Grid> */}

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('purchased_date')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='purchasedDate'
                name='purchasedDate'
                type='date'
                // defaultValue="2017-05-24"
                required
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                value={data.purchasedDate || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.purchasedDate.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.purchasedDate.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.purchasedDate.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('version')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='version'
                name='version'
                fullWidth
                value={data.version || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('use_for_localization')} />
            </Grid>
            <Grid item xs={12} sm={10} container>
              <Checkbox
                style={{ paddingTop: 20, paddingLeft: 0 }}
                id='useForLocalization'
                name='useForLocalization'
                checked={data.useForLocalization ? true : false}
                onChange={this.handleChangeLocalizationCheckbok}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('default_out_of_area')} />
            </Grid>
            <Grid item xs={12} sm={10} container>
              <Checkbox
                style={{ paddingTop: 20, paddingLeft: 0 }}
                id='outOfAreaDefault'
                name='outOfAreaDefault'
                checked={data.outOfAreaDefault ? true : false}
                onChange={this.handleChangeOutOfAreaCheckbok}
              />
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleCreateRouter(data)}
                  className={classes.button}
                >
                  {t('create')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;
    const router = this.props.router.toJS();
    const { routerTypes } = this.props.routerType.toJS();
    return (
      <React.Fragment>
        <Loader loading={router.loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_router')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || 0}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled={data.mapId ? true : false}
                >
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || 'tenants'}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId.flag : true}
                id='component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.name.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('place_name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='placeName'
                name='placeName'
                fullWidth
                value={data.placeName}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.placeName.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.placeName.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.placeName.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('router_id')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='routerId'
                name='routerId'
                fullWidth
                value={data.routerId}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.routerId.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.routerId.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.routerId.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('router_reference_number')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='referenceNumber'
                name='referenceNumber'
                fullWidth
                value={data.referenceNumber}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('router_type')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.routerType}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'routerType',
                    id: 'routerType',
                  }}
                >
                  {(routerTypes.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || 'routerType'}`}
                      {/* {`${val.name || 'deviceType'} (${val.name ||'device id'})`} */}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.routerType.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.routerType.msg}`)}
              </FormHelperText>
            </Grid>

            {/* <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('manufacturer_id')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id="manufacturer"
                name="manufacturer"
                fullWidth
                value={data.manufacturer}
                onChange={this.handleChange}
                variant="outlined"
                margin="dense"
                error={!data.reset ? this.state.errorField.manufacturer.flag : false}
              />
              <FormHelperText
                error
                hidden={
                  !data.reset ? !this.state.errorField.manufacturer.flag : true
                }
                id="component-error-text"
              >
                {t(`${this.state.errorField.manufacturer.msg}`)}
              </FormHelperText>
            </Grid> */}

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('purchased_date')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='purchasedDate'
                name='purchasedDate'
                type='date'
                // defaultValue="2017-05-24"
                required
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                value={data.purchasedDate || ''}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.purchasedDate.flag : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.purchasedDate.flag : true}
                id='component-error-text'
              >
                {t(`${this.state.errorField.purchasedDate.msg}`)}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('version')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='version'
                name='version'
                fullWidth
                value={data.version}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('use_for_localization')} />
            </Grid>
            <Grid item xs={12} sm={10} container>
              <Checkbox
                style={{ paddingTop: 20, paddingLeft: 0 }}
                id='useForLocalization'
                name='useForLocalization'
                checked={data.useForLocalization ? true : false}
                onChange={this.handleChangeLocalizationCheckbok}
                // fullWidth
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('default_out_of_area')} />
            </Grid>
            <Grid item xs={12} sm={10} container>
              <Checkbox
                style={{ paddingTop: 20, paddingLeft: 0 }}
                id='outOfAreaDefault'
                name='outOfAreaDefault'
                checked={data.outOfAreaDefault ? true : false}
                onChange={this.handleChangeOutOfAreaCheckbok}
                // fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleEditRouter(data)}
                  className={classes.button}
                >
                  {t('edit')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { loading } = this.props.router.toJS();
    const { routerTypes } = this.props.routerType.toJS();
    const { data, tenants } = this.state;

    const { classes, t } = this.props;
    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_router')} />
          {data && (
            <Grid container spacing={16} className={classes.wrapContain}>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('tenant')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                  <Select
                    value={data.tenantId || 0}
                    inputProps={{
                      name: 'tenantId',
                      id: 'tenantId',
                    }}
                    disabled
                  >
                    {(tenants || []).map((val) => (
                      <MenuItem fullwidth='true' key={val.id} value={val.id}>
                        {`${val.name || 'tenants'}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('name')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='name'
                  name='name'
                  fullWidth
                  value={data.name || '-'}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('place_name')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='placeName'
                  name='placeName'
                  fullWidth
                  value={data.placeName || '-'}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('router_id')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='routerId'
                  name='routerId'
                  fullWidth
                  value={data.routerId || '-'}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('router_reference_number')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  required
                  id='referenceNumber'
                  name='referenceNumber'
                  fullWidth
                  value={data.referenceNumber || '-'}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('router_type')} required />
              </Grid>
              <Grid item xs={12} sm={10}>
                <Paper className={`selectInput ${classes.spaceTop}`}>
                  <Select
                    value={data.routerType}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'routerType',
                      id: 'routerType',
                    }}
                    disabled
                  >
                    {(routerTypes.data || []).map((val) => (
                      <MenuItem fullwidth='true' key={val.id} value={val.id}>
                        {`${val.name || 'routerType'}`}
                      </MenuItem>
                    ))}
                  </Select>
                </Paper>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('assigned_date')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='assigned_date'
                  name='assigned_date'
                  fullWidth
                  value={data.assignedDate && moment(data.assignedDate).format('DD MMMM YYYY, HH:mm')}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('purchased_date')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='purchasedDate'
                  name='purchasedDate'
                  fullWidth
                  value={data.purchasedDate && moment(data.purchasedDate).format('DD MMMM YYYY, HH:mm')}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('description')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='description'
                  name='description'
                  fullWidth
                  value={data.description || '-'}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('version')} />
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  id='version'
                  name='version'
                  fullWidth
                  value={data.version || '-'}
                  variant='outlined'
                  margin='dense'
                  disabled
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('use_for_localization')} />
              </Grid>
              <Grid item xs={12} sm={10} container>
                <Checkbox
                  style={{ paddingTop: 20, paddingLeft: 0 }}
                  id='use_for_localization'
                  name='use_for_localization'
                  checked={data.useForLocalization !== null ? data.useForLocalization : true}
                  disabled
                  // fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormInputLabel label={t('default_out_of_area')} />
              </Grid>
              <Grid item xs={12} sm={10} container>
                <Checkbox
                  style={{ paddingTop: 20, paddingLeft: 0 }}
                  id='out_of_area'
                  name='out_of_area'
                  checked={data.outOfAreaDefault ? true : false}
                  disabled
                  // fullWidth
                />
              </Grid>
              {/* <Grid item xs={6}>
                <div style={{ fontSize: '16px', color: '#4a4a4a' }}>
                  Name:{' '}
                  <span style={{ fontSize: '14px' }}>
                    {viewDetail.name || '-'}
                  </span>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div style={{ fontSize: '16px', color: '#4a4a4a' }}>
                  Router ID:{' '}
                  <span style={{ fontSize: '14px' }}>
                    {viewDetail.serial || '-'}
                  </span>
                </div>
              </Grid> */}
              {/* <Grid item xs={6}>
                <div style={{ fontSize: '16px', color: '#4a4a4a' }}>
                  Map:{' '}
                  <span style={{ fontSize: '14px' }}>
                    {viewDetail.map || 'Not Assigned'}
                  </span>
                </div>
              </Grid> */}
              {/* <Grid item xs={6}>
                <div style={{ fontSize: '16px', color: '#4a4a4a' }}>
                  Manufacturer:{' '}
                  <span style={{ fontSize: '14px' }}>
                    {viewDetail.manufacturer || '-'}
                  </span>
                </div>
              </Grid> */}
              {/* <Grid item xs={6}>
                <div style={{ fontSize: '16px', color: '#4a4a4a' }}>
                  Assigned Date:{' '}
                  <span style={{ fontSize: '14px' }}>
                    {moment(viewDetail.createdDate).format(
                      'DD MMMM YYYY, HH:mm'
                    ) || '-'}
                  </span>
                </div>
              </Grid> */}
              {/* <Grid item xs={6}  alignItems="center">
                <div style={{ fontSize: '16px', color: '#4a4a4a' }}>
                  Default Out of Area:{' '}
                  <span style={{ fontSize: '14px' }}>
                    {viewDetail.outOfAreaDefault || '-'}
                  </span>
                </div>
              </Grid> */}
              <Grid item xs={12}>
                <div className={classes.buttons}>
                  <Button className={classes.button} onClick={this.goBack}>
                    {t('back')}
                  </Button>
                </div>
              </Grid>
            </Grid>
          )}
        </Paper>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/routers/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}

const styles = (theme) => ({
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  spaceTop: {
    marginTop: '10px',
  },
});
export const page = inject('router', 'routerType')(observer(RoutersPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
